import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default () => ({
  path: ":curriculumProgramId",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "schoolSettings" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
});
